/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';

const CheckBoxInput = ({
  name,
  label,
  onChange,
  error,
  className,
  checked,
  fieldClass,
  options,
  contextHelp
}) => {
  let wrapperClass = 'form-group';
  if (error && error.length > 0) {
    wrapperClass += " has-error";
  }
  return (
    <fieldset className={fieldClass}>
      <div className={wrapperClass}>
        <legend>
          <label htmlFor={name}>{label}</label>
        </legend>
        <div className="checkbox-button-container">
          {options.map((option) => {
            return (
              <div key={option.key} className="checkbox input-container">
                <label>
                  <input
                    type="checkbox"
                    name={name}
                    className={className}
                    value={option.value}
                    onChange={onChange}
                    checked={checked}/> {option.key}
                </label>
              </div>
            );
          })
          }
        </div>
        {error && <div tabIndex="0" className="error-message">{error}</div>}
        <div
          className="context-help"
          dangerouslySetInnerHTML={{
          __html: contextHelp
        }}/>
      </div>
    </fieldset>
  );
};

CheckBoxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string,
  checked: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  fieldClass: PropTypes.string,
  contextHelp: PropTypes.string
};

export default CheckBoxInput;



/** WEBPACK FOOTER **
 ** ./src/components/common/CheckBoxInput.js
 **/